// extracted by mini-css-extract-plugin
export default {"wrap":"U_MqEtjNtl9dGDYJzRXC"};